/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import {
  QueryClient,
  QueryFunctionContext,
  QueryKey,
} from "@tanstack/react-query";
import { GramCore } from "../core.js";
import { accessListChallengeBuckets } from "../funcs/accessListChallengeBuckets.js";
import { combineSignals } from "../lib/primitives.js";
import { RequestOptions } from "../lib/sdks.js";
import { ListChallengeBucketsResult } from "../models/components/listchallengebucketsresult.js";
import {
  ListChallengeBucketsRequest,
  ListChallengeBucketsSecurity,
  Outcome,
} from "../models/operations/listchallengebuckets.js";
import { unwrapAsync } from "../types/fp.js";
export type ChallengeBucketsQueryData = ListChallengeBucketsResult;

export function prefetchChallengeBuckets(
  queryClient: QueryClient,
  client$: GramCore,
  request?: ListChallengeBucketsRequest | undefined,
  security?: ListChallengeBucketsSecurity | undefined,
  options?: RequestOptions,
): Promise<void> {
  return queryClient.prefetchQuery({
    ...buildChallengeBucketsQuery(
      client$,
      request,
      security,
      options,
    ),
  });
}

export function buildChallengeBucketsQuery(
  client$: GramCore,
  request?: ListChallengeBucketsRequest | undefined,
  security?: ListChallengeBucketsSecurity | undefined,
  options?: RequestOptions,
): {
  queryKey: QueryKey;
  queryFn: (
    context: QueryFunctionContext,
  ) => Promise<ChallengeBucketsQueryData>;
} {
  return {
    queryKey: queryKeyChallengeBuckets({
      outcome: request?.outcome,
      principalUrn: request?.principalUrn,
      scope: request?.scope,
      projectId: request?.projectId,
      resolved: request?.resolved,
      limit: request?.limit,
      offset: request?.offset,
      gramKey: request?.gramKey,
      gramSession: request?.gramSession,
    }),
    queryFn: async function challengeBucketsQueryFn(
      ctx,
    ): Promise<ChallengeBucketsQueryData> {
      const sig = combineSignals(
        ctx.signal,
        options?.signal,
        options?.fetchOptions?.signal,
      );
      const mergedOptions = {
        ...options?.fetchOptions,
        ...options,
        signal: sig,
      };

      return unwrapAsync(accessListChallengeBuckets(
        client$,
        request,
        security,
        mergedOptions,
      ));
    },
  };
}

export function queryKeyChallengeBuckets(
  parameters: {
    outcome?: Outcome | undefined;
    principalUrn?: string | undefined;
    scope?: string | undefined;
    projectId?: string | undefined;
    resolved?: boolean | undefined;
    limit?: number | undefined;
    offset?: number | undefined;
    gramKey?: string | undefined;
    gramSession?: string | undefined;
  },
): QueryKey {
  return ["@gram/client", "access", "listChallengeBuckets", parameters];
}
